import { observer } from "mobx-react";
import ValueRange from "../../../../components/value-range/value-range";
import { RefundTypeProps } from "../refund-type-props";

const OfferRange: React.FC<RefundTypeProps> = observer(({ resolution }) => {
    const varinatPriceRanges = resolution?.getOfferRanges();

    return (
        <ValueRange
            from={{
                value: resolution?.rangeFrom,
                default: varinatPriceRanges?.[0] ?? 0,
                callback: (v) => resolution?.setRangeFrom(v),
            }}
            to={{
                value: resolution?.rangeTo,
                default: varinatPriceRanges?.[1] ?? 0,
                callback: (v) => resolution?.setRangeTo(v),
            }}
        />
    );
});

export default OfferRange;